const initialFormData = {
  filename: '',
  base64: '',
  dealerId: null,
};
export default {
  data() {
    return {
      tables: {
        headers: [
          { text: 'Название', value: 'product.name', sortable: false, align: 'left' },
          { text: 'Кол-во', value: 'quantity', sortable: false, align: 'right' },
        ],
      },
      history: [],
      showHistoryID: false,
      editStatuses: ['adminReview', 'draft', 'redo'],
      showPhoto: false,
      currentPhoto: null,
      showPdf: false,
      currentPdf: null,
      isLoadPage: false,
      isFormOpen: false,
      formData: { ...initialFormData },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    sales() {
      return this.$store.state.sales.sales;
    },
    loading() {
      return this.$store.state.loading;
    },
    cantSave() { return !this.formData?.base64; },
  },
  methods: {
    isEdit(status) {
      return this.editStatuses.indexOf(status) > -1;
    },
    DownloadDocument(saleId) {
      console.log(saleId);
      this.$store.dispatch('DownloadFile', {
        url: 'sales/api/sale/download-blob',
        data: {
          profile_id: this.user.profile_id,
          sale_id: saleId,
        },
        filename: `отчет_о_продаже_${saleId}_${this.user.profile_id}.pdf`,
      });
      // для скачивания документа на подпись
    },
    OnFormOpen(saleId) {
      this.formData.saleId = saleId;
      this.isFormOpen = true;
    },
    PickDocument() {
      this.$refs.file.click();
    },
    OnFilePicked(e) {
      const app = this;
      const { files } = e.target;
      if (files[0] !== undefined) {
        app.formData.filename = files[0].name;
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          app.formData.base64 = fr.result;
          app.$forceUpdate();
        });
      }
    },
    UploadDocument() {
      const app = this;
      app.$store.getters.axl.post('sales/api/sale/upload', {
        profile_id: this.user.profile_id,
        sale_id: this.formData.saleId,
        documents: this.formData.base64,
      })
        .then(() => {
          this.$store.dispatch('sales/GetSalesList', { profile_id: this.user.profile_id });
          app.isFormOpen = false;
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },

    getSaleQuantity(id) {
      const sale = this.sales.filter(item => item.id === id);
      let quantity = 0;
      if (sale[0].positions) {
        quantity = sale[0].positions.reduce((acc1, d1) => {
          acc1 += d1.quantity;
          return acc1;
        }, 0);
      }
      return quantity;
    },
    getSaleBonuses(id) {
      const sale = this.sales.filter(item => item.id === id);
      let bonuses = 0;
      if (sale[0].positions) {
        bonuses = sale[0].positions.reduce((acc1, d1) => {
          acc1 += d1.bonuses;
          return acc1;
        }, 0);
      }
      return bonuses;
    },
    addSale(id, actionId) {
      this.$store.dispatch('sales/GetSale', id);
      this.$router.push(`/sale/${actionId}/${id}`);
    },
    showHistory(id) {
      const sale = this.sales.filter(item => item.id === id);
      this.history = sale.length ? sale[0].history : [];
      this.showHistoryID = (this.showHistoryID !== id) ? id : false;
    },
    getStatusColor(status) {
      switch (status) {
        case 'redo': return 'color-orange';
        case 'draft': return 'color-orange';
        case 'declined': return 'color-red';
        case 'paid': return 'color-green';
        case 'approved': return 'color-green';
        case 'verified': return 'color-green';
        case 'adminReview': return 'color-blue';
        case 'file_added': return 'color-blue';
        default: return '';
      }
    },
    ShowPhoto(photo) {
      this.showPhoto = true;
      this.currentPhoto = { ...photo };
    },
    ClosePhoto() {
      this.showPhoto = false;
      this.currentPhoto = null;
    },
    ShowPdf(photo) {
      this.showPdf = true;
      this.currentPdf = `<iframe src="${photo.url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
    CheckPDF(photo) {
      if (photo.base64) {
        return (photo.base64.indexOf('/pdf;') !== -1);
      }
      if (photo.url) {
        return (photo.url.indexOf('.pdf') !== -1);
      }
      return false;
    },
    ClosePdf() {
      this.showPdf = false;
      this.currentPdf = null;
    },
  },
  mounted() {
    this.$store.dispatch('sales/GetSalesList', { profile_id: this.user.profile_id });
    // this.$store.dispatch('sales/GetProductsList');
  },
};
